import {Component, OnInit} from '@angular/core';
import {Star, StarColor} from '../../../models/models';
import * as _ from 'lodash';

@Component({
  selector: 'longmoon-constellation',
  templateUrl: './constellation.component.html',
  styleUrls: ['./constellation.component.scss']
})
export class ConstellationComponent implements OnInit {
  contellationLeo: Star[];

  leoStarCoords = [
    {x: 2.86, y: 67.85},
    {x: 51.97, y: 35.99},
    {x: 125.04, y: 40.17},
    {x: 129.29, y: 19.98},
    {x: 161.12, y: 4.22},
    {x: 170.83, y: 16.02},
    {x: 142.99, y: 57.47},
    {x: 142.58, y: 84.99},
    {x: 50.89, y: 65.02}
  ];

  constructor() {
  }

  ngOnInit(): void {
    this.contellationLeo = this.leoStarCoords.map(c => {
      return {
        x: Math.floor(c.x),
        y: Math.floor(c.y),
        period: Math.ceil((Math.random() * 3) + 6),
        color: StarColor.White,
        size: 2
      };
    });
  }
}
